export type SupportErrors = Record<string, string>
export const defaultErrorsState: SupportErrors = {}
